export enum CheckoutStatus {
  inProgress = 1,
  paid,
  refunded,
}
